module.exports = __webpack_public_path__ + "img/info_2024.c180e059.png";